import { browserHistory } from 'services/ServiceRegistry';

import Form from '../_.extend';

export const makeFields: Function = (t: Function) => {
  return [
    {
      // CHOOSE ACCOUNT
      name: 'additionalInfo',
      label: '',
      fields: [
        {
          name: 'companyName',
          label: t('general:labels.company_name'),
          placeholder: '',
          rules: 'required',
          value: '',
        },
        {
          name: 'contactPhoneNo',
          label: t('general:labels.contact_phone_number'),
          rules: 'required',
          value: '',
        },
        {
          name: 'country',
          label: t('general:country'),
          rules: 'required',
          value: '',
        },
        {
          name: 'stateCountryProvince',
          label: t('general:state_county_province'),
          rules: 'required',
          value: '',
        },
      ],
    },
  ];
};

class UserFormDetails extends Form {}

export const userDetails: Function = (fields: Array<*>, localState: Object, t: Function) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      browserHistory.push('/account-numbers', form.values().additionalInfo);
    },
    onError(form: Object) {
      localState.responseMessage = t('general:messages.form_invalid');
      localState.showResponseMessage = true;
      console.log('errors: ', form.values());
    },
  };

  return new UserFormDetails({ fields }, { hooks, name: t('general:actions.create_new_project') });
};
